import { Box } from '@mui/material'
import React from 'react'
import FAQs from '../../pages/eater/about/components/FAQs'
import { POINTS_FAQ_DATA } from '../../constants/pointsFaq'

const PointsFaqSection: React.FC = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <FAQs
        faqData={POINTS_FAQ_DATA}
        title="Frequently asked questions"
        subTitle="Everything you need to know about earning and redeeming points"
        titleTypography="h5"
      />
    </Box>
  )
}

export default PointsFaqSection



